module.exports = __webpack_public_path__ + "img/help.0b4f7b40.svg";